export const DEEZER_AUTH_RESULT_PARAM = 'deezerAuthResult';
